import { p as proxyCustomElement, H, c as createEvent, h, d as Host } from './p-ae815584.js';
import { b as bem } from './p-c44c2366.js';
import { d as defineCustomElement$5 } from './p-d6589175.js';
import { d as defineCustomElement$4 } from './p-176a7322.js';
import { d as defineCustomElement$3 } from './p-71f91db6.js';
import { d as defineCustomElement$2 } from './p-db87170c.js';
import { t as transformTagName } from './p-c01ca34a.js';

const cosmosOptionCss = ":host{display:block;max-width:100%;position:relative;width:100%}:host(:focus){outline:none}:host(:focus)::before{content:\"\";border-radius:calc(2.66px * 1.5);bottom:calc((4px + -4px) * -1);-webkit-box-shadow:inset 0 0 0 2px #1B6AEE, 0 0 0 2px #FFFFFF;box-shadow:inset 0 0 0 2px #1B6AEE, 0 0 0 2px #FFFFFF;left:calc((4px + -4px) * -1);position:absolute;right:calc((4px + -4px) * -1);top:calc((4px + -4px) * -1)}.cosmos-option{-ms-flex-align:center;align-items:center;border-radius:4px;-webkit-box-sizing:border-box;box-sizing:border-box;cursor:default;display:-ms-flexbox;display:flex;gap:6px;-ms-flex-pack:justify;justify-content:space-between;margin:0;max-width:100%;padding:6px 8px;position:relative;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;width:100%;--cosmos-text-color:var(--cosmos-option-color);--cosmos-text-font-family:var(--cosmos-option-font-family);--cosmos-text-font-size:var(--cosmos-option-font-size);--cosmos-text-font-style:var(--cosmos-option-font-style);--cosmos-text-font-weight:var(--cosmos-option-font-weight);--cosmos-text-letter-spacing:var(--cosmos-option-letter-spacing);--cosmos-text-line-height:var(--cosmos-option-line-height);--cosmos-text-text-transform:var(--cosmos-option-text-transform)}.cosmos-option__side{-ms-flex-align:center;align-items:center;display:-ms-flexbox;display:flex;gap:var(--cosmos-option-gap, 6px);max-width:-moz-fit-content;max-width:-webkit-fit-content;max-width:fit-content;min-width:0}.cosmos-option__icon{--cosmos-icon-color:#000F1E;-ms-flex-line-pack:center;align-content:center;-ms-flex:0 0 auto;flex:0 0 auto;height:18px;width:18px}.cosmos-option__checkbox{width:18px}.cosmos-option__meta{--cosmos-text-font-family:var(--cosmos-option-meta-font-family);--cosmos-text-font-size:var(--cosmos-option-meta-font-size);--cosmos-text-font-style:var(--cosmos-option-meta-font-style);--cosmos-text-font-weight:var(--cosmos-option-meta-font-weight)}.cosmos-option--selected{background:rgba(0, 15, 30, 0.05)}.cosmos-option--disabled{--cosmos-text-color:rgba(0, 15, 30, 0.45)}.cosmos-option--disabled .cosmos-option__icon{--cosmos-icon-color:rgba(0, 15, 30, 0.45)}.cosmos-option:hover:not(.cosmos-option--disabled){background:rgba(0, 15, 30, 0.05)}.cosmos-option--appearance-light .cosmos-option__icon{--cosmos-icon-color:#FFFFFF}.cosmos-option--appearance-light.cosmos-option--disabled{--cosmos-text-color:rgba(255, 255, 255, 0.45)}.cosmos-option--appearance-light.cosmos-option--disabled .cosmos-option__icon{--cosmos-icon-color:rgba(255, 255, 255, 0.45)}.cosmos-option--appearance-light:hover:not(.cosmos-option--disabled){background:rgba(255, 255, 255, 0.1)}.cosmos-option--appearance-light.cosmos-option--selected{background:rgba(255, 255, 255, 0.1)}.cosmos-option ::slotted([slot=prefix]){-ms-flex:0 0 auto;flex:0 0 auto;--cosmos-icon-size:18px;--cosmos-flag-width:18px;--cosmos-avatar-size:18px}";
const CosmosOptionStyle0 = cosmosOptionCss;

const generateClassNames = bem('cosmos-option');
const CosmosOption$1 = /*@__PURE__*/ proxyCustomElement(class CosmosOption extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.optionselectEvent = createEvent(this, "optionselect", 7);
        this.appearance = 'dark';
        this.disabled = false;
        this.meta = '';
        this.selected = false;
        this.value = '';
        this.showCheckbox = false;
    }
    handleSelectedChange(newValue, currentValue) {
        if (newValue !== currentValue) {
            this.optionselectEvent.emit({ value: this.value });
        }
    }
    clickHandler() {
        if (this.disabled) {
            return;
        }
        this.optionselectEvent.emit({ value: this.value });
    }
    composeTitle() {
        var _a;
        const label = (_a = this.element.textContent) === null || _a === void 0 ? void 0 : _a.trim();
        if (this.meta) {
            return `${label} • ${this.meta}`;
        }
        return label;
    }
    componentWillLoad() {
        const closestSelect = this.element.closest(transformTagName('cosmos-select'));
        if (closestSelect === null || closestSelect === void 0 ? void 0 : closestSelect.hasAttribute('multiple')) {
            this.showCheckbox = true;
        }
    }
    render() {
        var _a;
        return (h(Host, { key: '62cbbf0420cb52c187a4c0a5c813cf109238dcad', role: "option", "aria-label": (_a = this.element.textContent) === null || _a === void 0 ? void 0 : _a.trim(), "aria-selected": this.selected.toString(), "aria-disabled": this.disabled ? 'true' : undefined }, h("div", { key: '0e758e012b3c9dd5e3be7d6c0b2880c53213abd6', class: generateClassNames({
                disabled: this.disabled,
                appearance: this.appearance,
                selected: this.selected,
            }), part: "base" }, h("div", { key: '99b12f0dab6ffc89116004608679d6899e188b60', title: this.composeTitle(), class: generateClassNames('side') }, this.showCheckbox && (h("cosmos-checkbox", { key: 'b298faf6ae151c0ae4d31fa35b8a8cbdf00edab8', appearance: this.appearance, checked: this.selected, class: generateClassNames('checkbox'), tabIndex: -1 })), h("slot", { key: '102a36d7b5dd3ff5fc87cb776023d3ed162faaa5', "aria-hidden": "true", name: "prefix" }), h("cosmos-text", { key: '40618ff54a3d5accaafd07272ff907e184a17fca', appearance: this.appearance, exportparts: "base: label", class: generateClassNames('label'), size: "small", clamp: 1 }, h("span", { key: 'ac86ddb920b3fd43d889a3c3e6818c364e9efb1b' }, h("slot", { key: '9c0b8a71db0358e76f5bb563623f2b6590eae8f0' })))), h("div", { key: 'ef5ddc983a8ffba0b2b9e08bc4b508ecf5628c5a', class: generateClassNames('side') }, this.meta && (h("cosmos-text", { key: '4ef18754ff9af8e6e4c2f6ebcaba19899a68aa7e', kind: "subtle", appearance: this.appearance, class: generateClassNames('meta'), clamp: 1, size: "x-small" }, this.meta)), this.selected && !this.showCheckbox && (h("cosmos-icon-checkmark", { key: '0fc003dd87aae6405cc3e338b296e86ad0732b7b', class: generateClassNames('icon') }))))));
    }
    get element() { return this; }
    static get watchers() { return {
        "selected": ["handleSelectedChange"]
    }; }
    static get style() { return CosmosOptionStyle0; }
}, [1, "cosmos-option", {
        "appearance": [513],
        "disabled": [516],
        "meta": [513],
        "selected": [516],
        "value": [513],
        "showCheckbox": [32]
    }, [[0, "click", "clickHandler"]], {
        "selected": ["handleSelectedChange"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-option", "cosmos-checkbox", "cosmos-icon-checkmark", "cosmos-icon-warning", "cosmos-text"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-option":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosOption$1);
            }
            break;
        case "cosmos-checkbox":
            if (!customElements.get(tagName)) {
                defineCustomElement$5();
            }
            break;
        case "cosmos-icon-checkmark":
            if (!customElements.get(tagName)) {
                defineCustomElement$4();
            }
            break;
        case "cosmos-icon-warning":
            if (!customElements.get(tagName)) {
                defineCustomElement$3();
            }
            break;
        case "cosmos-text":
            if (!customElements.get(tagName)) {
                defineCustomElement$2();
            }
            break;
    } });
}

const CosmosOption = CosmosOption$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosOption, defineCustomElement };
